import { render, staticRenderFns } from "./EducatorEdit.vue?vue&type=template&id=9aa0f676&"
import script from "./EducatorEdit.vue?vue&type=script&lang=js&"
export * from "./EducatorEdit.vue?vue&type=script&lang=js&"
import style0 from "./EducatorEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports